<template>
    <div class="px-5">
        <v-alert v-if="isAdmin" text icon="mdi-information" color="primary" dense class="pt-3">
            Es gibt noch keinen Bewerb für deine Auswahl!
            <div class="py-3">
                <v-btn color="primary" @click="addNewBewerb()">
                    <v-icon class="mr-2">mdi-plus</v-icon>
                    Bewerb anlegen
                </v-btn>
            </div>
        </v-alert>
        <v-alert v-else text icon="mdi-information" color="primary" dense class="py-5">
            Es wurde noch keine Meisterschaft für deine Auswahl angelegt!
        </v-alert>
    </div>
</template>

<script>
export default {
    name: "meisterschaftBewerbEmpty",
    props: ['landesverbandId'],
    computed: {
        isAdmin(){ return this.$store.getters["user/isMeisterschaftAdmin"](this.landesverbandId)},
    },
    methods: {
        addNewBewerb(){
            this.$emit('addBewerb', 'editBewerb');
        }
    },
}
</script>

<style scoped>

</style>